import { ReactComponent as fimilyfisinggoalSVG } from "../assets/img/fimilyfishingprotectiongoal.svg";
import { ReactComponent as childreneducationgoalSVG } from "../assets/img/childrenEducationgoal.svg";
import { ReactComponent as childrenMarriagegoalSVG } from "../assets/img/childrenmarriagegoal.svg";
import { ReactComponent as housesearchinginvestmentgoal } from "../assets/img/housesearchinggoal.svg";
import { ReactComponent as Ritementtgoal } from "../assets/img/reitementgoal.svg";
export const goalArray = [
  {
    id: 1,
    Title: "Protection",
    tooltip:
      "Secure your family’s future with term plan, ensuring their financial stability in your absence.",
    goalSVG: fimilyfisinggoalSVG,
  },
  {
    id: 2,
    Title: "Children’s Education",
    tooltip:
      "Fund your child’s academic future ensuring they have required resources in place for success.",
    goalSVG: childreneducationgoalSVG,
  },
  {
    id: 2,
    Title: "Children’s Marriage",
    tooltip:
      "Plan for the special day of your child by providing a strong financial backup.",
    goalSVG: childrenMarriagegoalSVG,
  },
  {
    id: 4,
    Title: "Investment",
    // Title: "Retirement",
    tooltip:
      "Achieve your financial goals by maximising returns and growing your wealth through strategic investment options.",

    goalSVG: housesearchinginvestmentgoal,
  },
  {
    id: 5,
    Title: "Retirement",

    // Title: "Investment",
    tooltip:
      "Planning for a financially secured retirement is a best practice needed for making your golden years comfortable.",

    goalSVG: Ritementtgoal,
  },
];
